import React, { Component } from "react";
import "./stylesheets/pending.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  getBackSiteid,
  getBackJobsIncentive,
  getSubmitIncentive,
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import DatePicker from "react-datepicker";
import { Button } from "react-bootstrap";
import overlayFactory from "react-bootstrap-table2-overlay";

export default class Pending extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Incentivedetails: [],
      expanded: [0, 1],
      currnetmonthdata: new Date(),
      submitbtn: false,
      loading: false,
      loadingData: "No data found",
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var sendData = {
      userid: userId,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendData);
      const datarespsites = await responsesites;
      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteIdArr.push(siteId);
      }
      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        siteId: siteIdArr[0].key,
      });
    };
    fetchsiteid();
  }

  handleInputFetch = (event) => {
    var submitbtn = false;
    var loadingData = "No data Found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = dateData.getFullYear();
    const siteId = this.state.siteId;
    const statusId = this.state.statusId;
    var sendData = {
      month: monthData + 1,
      year: year,
      site_id: siteId,
      status_id: statusId,
    };
    const fetchIncentivedetails = async () => {
      const responseIncentive = await getBackJobsIncentive(sendData);
      const datarespIncentive = await responseIncentive;
      if (datarespIncentive.length > 0) {
        const filtered = datarespIncentive.filter((obj) => {
          return obj.ShowSubmit === true;
        });
        if (filtered.length > 0) {
          submitbtn = filtered[0].ShowSubmit;
        }
      } else {
        loadingData = "No data found";
      }
      this.setState({
        Incentivedetails: datarespIncentive,
        submitbtn: submitbtn,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchIncentivedetails();
  };

  handleInputChange = (event) => {
    this.setState({
      currnetmonthdata: event,
      Incentivedetails: [],
      submitbtn: false,
    });
  };

  // priceFormatter = event => {
  // if(event === 0){
  //   return '';
  // }else{
  //   return parseFloat(event);
  // }
  // }

  render() {
    var currnetMonthData = this.state.currnetmonthdata;
    var currnetMonth = "";
    var columns = "";
    if (currnetMonthData === "") {
      currnetMonth = new Date();
    } else {
      currnetMonth = currnetMonthData;
    }

    columns = [
      {
        dataField: "SiteName",
        text: "Site Name",
        editable: false,
      },
      {
        dataField: "Status",
        text: "Status",
        editable: false,
      },
      {
        dataField: "all1",
        text: "1",
        classes: "amountMul",
      },
      {
        dataField: "all2",
        text: "2",
        classes: "amountMul",
      },
      {
        dataField: "all3",
        text: "3",
        classes: "amountMul",
      },
      {
        dataField: "all4",
        text: "4",
        classes: "amountMul",
      },
      {
        dataField: "all5",
        text: "5",
        classes: "amountMul",
      },
      {
        dataField: "all6",
        text: "6",
        classes: "amountMul",
      },
      {
        dataField: "all7",
        text: "7",
        classes: "amountMul",
      },
      {
        dataField: "all8",
        text: "8",
        classes: "amountMul",
      },
      {
        dataField: "all9",
        text: "9",
        classes: "amountMul",
      },
      {
        dataField: "all10",
        text: "10",
        classes: "amountMul",
      },
      {
        dataField: "all11",
        text: "11",
        classes: "amountMul",
      },
      {
        dataField: "all1",
        text: "1",
        classes: "amountMul",
      },
      {
        dataField: "all12",
        text: "12",
        classes: "amountMul",
      },
      {
        dataField: "all13",
        text: "13",
        classes: "amountMul",
      },
      {
        dataField: "all14",
        text: "14",
        classes: "amountMul",
      },
      {
        dataField: "all15",
        text: "15",
        classes: "amountMul",
      },
      {
        dataField: "all16",
        text: "16",
        classes: "amountMul",
      },
      {
        dataField: "all17",
        text: "17",
        classes: "amountMul",
      },
      {
        dataField: "all18",
        text: "18",
        classes: "amountMul",
      },
      {
        dataField: "all19",
        text: "19",
        classes: "amountMul",
      },
      {
        dataField: "all0",
        text: "20",
        classes: "amountMul",
      },
      {
        dataField: "all21",
        text: "21",
        classes: "amountMul",
      },
      {
        dataField: "all22",
        text: "22",
        classes: "amountMul",
      },
      {
        dataField: "all23",
        text: "23",
        classes: "amountMul",
      },
      {
        dataField: "all24",
        text: "24",
        classes: "amountMul",
      },
      {
        dataField: "all25",
        text: "25",
        classes: "amountMul",
      },
      {
        dataField: "all26",
        text: "26",
      },
      {
        dataField: "all27",
        text: "27",
        classes: "amountMul",
      },
      {
        dataField: "all28",
        text: "28",
        classes: "amountMul",
      },
      {
        dataField: "all29",
        text: "29",
        classes: "amountMul",
      },
      {
        dataField: "all30",
        text: "30",
        classes: "amountMul",
      },
      {
        dataField: "all31",
        text: "31",
        classes: "amountMul",
      },
      {
        dataField: "Total",
        text: "Total",
        editable: false,
      },
    ];

    var Incentive = this.state.Incentivedetails;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-pen">
            <div className="viewcalander">
              <DatePicker
                selected={currnetMonth}
                onChange={(date) => this.handleInputChange(date)}
                dateFormat="MMM yyyy"
                showMonthYearPicker
                className="input-date-data-in outLine font_size"
              />
            </div>

            <div className="filterbtn">
              <Button
                variant="primary"
                className="font_size"
                onClick={this.handleInputFetch}
              >
                Fetch
              </Button>
            </div>
          </div>
        </div>
        <div className="table-container-pen">
          <BootstrapTable
            classes="tabledata-all"
            keyField="JobID"
            id="tabledata"
            data={Incentive}
            columns={columns}
            noDataIndication={this.state.loadingData}
          />
        </div>
      </div>
    );
  }
}
